'use client'
import React, { useEffect, useState } from 'react'
import PaginationPluto from './Pagination'
import { canUsePagination, numberWithCommas } from '../utils'
import { socket } from '../Containers/MainContainer'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import SweetAlert from 'react-bootstrap-sweetalert'
import PlutoMenu from './PlutoMenu'
import VerifyAdmin from './PlutoVerify'
import { Link } from 'react-router-dom'


function PlutoPendingPTC(props) {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [today, setToday] = useState(undefined)
    const [rank, setRank] = useState(0)
    const [alert, setAlert] = useState({ show: false, user_id: -1, offer_id: -1, name: '' })
    useEffect(() => {
        socket.on('response_get_admin_ptc', (data) => {
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)
        })
        socket.on('reTakeUsersPTCDet', (data) => {
            socket.emit('getPendingPTCAdmin', {
                page,
                for_user: props.second_page
            })
        })
        socket.emit('getPendingPTCAdmin', {
            page,
            for_user: props.second_page
        })
    }, [])

    // Shared button styles
    const filterBtnBase = {
        padding: '8px 16px',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        background: '#21262d',
        border: '1px solid #30363d',
        color: '#c9d1d9',
        minWidth: '100px',
        textAlign: 'center',
    };

    const actionBtnStyle = {
        minWidth: '100px',
        maxWidth: '100px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#21262d',
        border: '1px solid #30363d',
        borderRadius: '8px',
        color: '#c9d1d9',
        fontSize: '12px',
        fontWeight: 500,
        cursor: 'pointer',
        textDecoration: 'none',
    };

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <SweetAlert
                show={alert.show}
                title={alert.title}
                onConfirm={function () {
                    socket.emit('adminAction', {
                        action: 'releaseOfferAdmin',
                        user_id: alert.user_id,
                        offer_id: alert.offer_id,
                    })
                    setAlert({ ...alert, show: false })
                }}
                style={{ backgroundColor: '#161b22', color: '#e6edf3', border: '1px solid #30363d' }}
                cancelBtnText="Not now"
                confirmBtnText="Proceed"
                showCancel={true}
                cancelBtnStyle={{ color: '#8b949e', textDecoration: 'none', background: '#21262d', border: '1px solid #30363d', borderRadius: '8px', padding: '6px 16px' }}
                confirmBtnStyle={{ border: 'none', boxShadow: 'none', padding: '6px 16px', backgroundColor: '#238636', borderRadius: '8px', color: '#fff' }}
                onCancel={function () { setAlert({ show: false, user_id: '', offer_id: '', name: '' }) }}
            >
                <>
                    <h3 style={{ color: '#e6edf3' }}>Do you want to release this offer?</h3>
                    <p style={{ color: '#c9d1d9' }}>Offer_name:{alert.name}</p>
                    <p style={{ color: '#c9d1d9' }}>Offer_id:{alert.offer_id}</p>
                    <p style={{ color: '#c9d1d9' }}>User_id:{alert.user_id}</p>
                </>

            </SweetAlert>
            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>

                {/* Filter Buttons */}
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', gap: '12px', marginBottom: '20px' }}>
                    <div style={{ ...filterBtnBase, background: today === true ? '#238636' : '#21262d', borderColor: today === true ? '#2ea043' : '#30363d', color: today === true ? '#fff' : '#c9d1d9' }} onClick={() => {
                        setToday(true)
                        socket.emit('getPendingPTCAdmin', {
                            page,
                            for_user: props.second_page,
                            today: true,
                        })
                    }}>Today</div>
                    <div style={{ ...filterBtnBase, background: today === undefined ? '#238636' : '#21262d', borderColor: today === undefined ? '#2ea043' : '#30363d', color: today === undefined ? '#fff' : '#c9d1d9' }} onClick={() => {
                        setToday(undefined)
                        socket.emit('getPendingPTCAdmin', {
                            page,
                            for_user: props.second_page,
                        })
                    }}>All</div>
                </div>

                {/* Stats Cards */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '24px' }}>
                    {userProfile.pendingAmount != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #d29922',
                            borderRadius: '12px',
                            padding: '16px 20px',
                        }}>
                            <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>
                                {numberWithCommas(userProfile.pendingAmount)}
                            </p>
                            <p style={{ fontSize: '12px', color: '#8b949e', margin: '4px 0 0 0', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Total pending {props.x == 1 ? `for uid_${props.second_page}` : ''}</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #58a6ff',
                            borderRadius: '12px',
                            padding: '16px 20px',
                        }}>
                            <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={{ fontSize: '12px', color: '#8b949e', margin: '4px 0 0 0', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Count pending</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Data Table */}
                <div style={{
                    overflow: 'auto',
                    margin: '0 auto',
                    padding: '20px',
                    marginBottom: '20px',
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                }}>
                    <p style={{ color: '#e6edf3', fontWeight: 600, fontSize: '16px', marginBottom: '16px' }}>Pending Offers</p>

                    {/* Table Header */}
                    <div style={{ fontWeight: 500 }}>
                        <div className="user-details-table-elements" style={{ borderBottom: '1px solid #21262d', paddingBottom: '10px' }}>
                            <div style={{ minWidth: '30px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>id</div>
                            <div style={{ minWidth: '250px', textAlign: 'left', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Name</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Wall</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Amount</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Clicks</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Promoted</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Social</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Daily Limit</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>FB Link</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Insta Link</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Twitter Link</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Telegram</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Pending</div>
                            <div style={{ minWidth: '50px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>type</div>
                        </div>
                    </div>

                    {/* Table Rows */}
                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: '#e6edf3', borderBottom: '1px solid #21262d' }}>
                                <div style={{ minWidth: '50px', color: '#8b949e' }} > {earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '250px', textAlign: 'left', color: '#e6edf3' }} >{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px', color: '#c9d1d9' }} >{earning.wall || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#3fb950' }} >{earning.amount || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#c9d1d9' }} >{earning.clicks || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px' }} >
                                    <span style={{
                                        padding: '3px 10px',
                                        borderRadius: '9999px',
                                        fontSize: '12px',
                                        background: earning.is_promoted == true ? 'rgba(63,185,80,0.15)' : 'rgba(248,81,73,0.15)',
                                        color: earning.is_promoted == true ? '#3fb950' : '#f85149',
                                    }}>{earning.is_promoted == true ? "yes" : "no"}</span>
                                </div>
                                <div style={{ minWidth: '150px' }} >
                                    <span style={{
                                        padding: '3px 10px',
                                        borderRadius: '9999px',
                                        fontSize: '12px',
                                        background: earning.is_social == true ? 'rgba(63,185,80,0.15)' : 'rgba(248,81,73,0.15)',
                                        color: earning.is_social == true ? '#3fb950' : '#f85149',
                                    }}>{earning.is_social == true ? "yes" : "no"}</span>
                                </div>
                                <div style={{ minWidth: '150px', color: '#c9d1d9' }} >{earning.daily_limit || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#58a6ff', fontSize: '12px', wordBreak: 'break-all' }} >{earning.fb_link || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#58a6ff', fontSize: '12px', wordBreak: 'break-all' }} >{earning.insta_link || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#58a6ff', fontSize: '12px', wordBreak: 'break-all' }} >{earning.twitter_link || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#58a6ff', fontSize: '12px', wordBreak: 'break-all' }} >{earning.telegram_link || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px' }} >
                                    <span style={{
                                        padding: '3px 10px',
                                        borderRadius: '9999px',
                                        fontSize: '12px',
                                        background: earning.pending == true ? 'rgba(210,153,34,0.15)' : 'rgba(63,185,80,0.15)',
                                        color: earning.pending == true ? '#d29922' : '#3fb950',
                                    }}>{earning.pending == true ? "yes" : "no"}</span>
                                </div>
                                <div style={{ minWidth: '150px', color: '#c9d1d9' }} >{earning.type == 1 ? "iframe" : "frameless"}</div>
                                <div
                                    onClick={() => {
                                        socket.emit('adminAction', {
                                            action: 'activatePTCAdmin',
                                            id: earning.id,
                                        })
                                    }}
                                    style={{ ...actionBtnStyle, background: '#238636', borderColor: '#2ea043', color: '#fff' }}
                                >{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Activate'}</div>
                                <div
                                    onClick={() => {
                                        socket.emit('adminAction', {
                                            action: 'pendPTCAdmin',
                                            id: earning.id,
                                        })
                                    }}
                                    style={{ ...actionBtnStyle, background: 'rgba(210,153,34,0.15)', borderColor: 'rgba(210,153,34,0.3)', color: '#d29922' }}
                                >{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Pend'}</div>
                                <Link to={`/pluto/user/${earning.user_id}`} style={{ ...actionBtnStyle, background: 'rgba(88,166,255,0.15)', borderColor: 'rgba(88,166,255,0.3)', color: '#58a6ff', fontSize: '10px' }}>{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Check User'}</Link>


                            </div>
                        )
                    })}
                </div>
                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getPendingPTCAdmin', {
                        username_like: username,
                        for_user: props.second_page,
                        page,
                        today,
                    })
                }} />}

            </div>

        </SkeletonTheme>
    )
}

export default PlutoPendingPTC
